(function () {
  'use strict';

  function initSection(section) {
    if (!section) return;
    var modal = section.querySelector('[data-artist-modal]');
    if (!modal) return;
    var sectionId = modal.dataset.sectionId;

    var slot = modal.querySelector('[data-artist-modal-slot]');
    var closeBtn = modal.querySelector('[data-artist-close]');
    var lastTrigger = null;

    function openModal(trigger) {
      var targetId = trigger.getAttribute('data-target');
      var tpl = section.querySelector('[data-artist-popup-content="' + targetId + '"]');
      if (!tpl || !slot) return;

      slot.innerHTML = '';
      slot.appendChild(tpl.content.cloneNode(true));
      lastTrigger = trigger;

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      slot.innerHTML = '';
      document.documentElement.style.overflow = '';
      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    }

    section.querySelectorAll('[data-artist-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(trigger);
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // 背景クリックで閉じる
    modal.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    // ESC（dialog の cancel）で閉じる際の後処理
    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeModal();
    });

    // close イベントでも後処理を保証
    modal.addEventListener('close', function () {
      slot.innerHTML = '';
      document.documentElement.style.overflow = '';
    });

    // 非対応ブラウザ向けの ESC フォールバック
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.hasAttribute('open') && typeof modal.showModal !== 'function') {
        closeModal();
      }
    });

    section.setAttribute('data-artist-grid-init', sectionId);
  }

  function initAll() {
    document
      .querySelectorAll('.section-artist-grid [data-artist-modal]:not([data-artist-grid-bound])')
      .forEach(function (modal) {
        modal.setAttribute('data-artist-grid-bound', 'true');
        initSection(modal.closest('.section-artist-grid') || modal.parentElement);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // テーマエディタでの再描画対応
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-artist-modal]');
    if (section) {
      var modal = section;
      modal.setAttribute('data-artist-grid-bound', 'true');
      initSection(modal.closest('.section-artist-grid') || event.target);
    }
  });
})();
